module.exports = __webpack_public_path__ + "media/images/covid/menu/restaurant-0ae011b7748e8d87de8d98b0ad4c787d.png";